import {createRouter, createWebHashHistory} from 'vue-router'
import siteConfig from '@/config/site'

const router = createRouter({
    history: createWebHashHistory(),  // hash 模式
    // history: createWebHistory(),  // history 模式
    // mode: 'hash',
    routes: [
        {
            path: '/',
            redirect: siteConfig.peoplePath,
        },
        {
            path: '/homepage',
            redirect: siteConfig.peoplePath,
        },
        {
            path: siteConfig.collegeBasePath,
            name: 'index',
            component: () => import('../views/IndexPage.vue'),
            children: [
                {
                    path: 'intro',
                    component: () => import('../views/FacultyIntro.vue'),
                },
                {
                    path: 'people',
                    component: () => import('../components/FacultyPeopleWrapper.vue'),
                },
                {
                    path: 'profile',
                    component: () => import('../components/FacultyPeopleWrapper.vue')
                },
                {
                    path: 'results',
                    component: () => import('../views/ResultsStatistics.vue')
                },
                {
                    path: 'edit',
                    component: () => import('../components/EditProfile.vue')
                },
            ],
            meta: {
                title: '师资主页',
            },
        },
        {
            path: '/allpeople',
            redirect: siteConfig.peoplePath,
        },
        {
            path: '/:pathMatch(.*)*',
            redirect: siteConfig.peoplePath,
        },
    ]
})

export default router
